import { getThemesComponent } from '@namespace/themes';
import { WagerContent as DefaultWagerContent } from './WagerContent';

export const WagerContent = getThemesComponent(
  DefaultWagerContent,
  'WagerContent'
);
